export default String.raw`
<dialog class="dialog check-deliveries check-deliveries-popup-js middle">
	<div class="dialog__header">
		<h2 class="dialog__header-title">{{translations.DeliverySchedule}}</h2>
		<form method="dialog">
			<button class="dialog__close close-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" height="24" width="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</form>
	</div>
	<div class="dialog__content">
		<div class="product">
			<div class="product__image-wrapper">
				{% if activeProduct.Image.Id > 0 and activeProduct.Image.Link -%}
					<img class="product__image" width="60" height="60" src="css/img/alo.gif" data-src="img/small/{{activeProduct.Image.Id}}/{{activeProduct.Image.Link}}" alt="{{activeProduct.NameNoHtml}}" loading="eager" fetchpriority="high">
				{% elsif activeProduct.Image.ExternalUrl -%}
					<img class="product__image" width="60" height="60" src="css/img/alo.gif" data-src="{{activeProduct.Image.ExternalUrl}}" alt="{{activeProduct.NameNoHtml}}" loading="eager" fetchpriority="high">
				{% else -%}
					<img class="product__image" width="60" height="60" src="css/img/alo.gif" data-src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" loading="eager" fetchpriority="high">
				{% endif -%}
			</div>
			<p class="product__name">{{activeProduct.NameNoHtml}}</p>
		</div>
		{% if usr.Authenticated -%}
			<p class="check-deliveries__not-ordered not-ordered-js">{{translations.ProductNotOrderedYet}}</p>
			<table class="check-deliveries__table check-deliveries-table-js">
				<colgroup>
					<col style="width:24.37%">
					<col style="width:37.82%">
					<col style="width:37.82%">
				</colgroup>
				<thead class="table__head">
					<tr class="table__row">
						<th class="table__cell">{{translations.Quantity}}</th>
						<th class="table__cell">{{translations.Status}}</th>
						<th class="table__cell">{{translations.PlannedDeliveryDate}}</th>
					</tr>
				</thead>
				<tbody class="table__body check-deliveries-table-content-js"></tbody>
			</table>
			<p class="check-deliveries__more-info more-info-js">{{translations.ContactForMore}}</p>
		{% else -%}
			<span class="check-deliveries__not-ordered">{{translations.AvailableAfterLogin}} <a href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}">{{translations.LoginToCheckDelivery}}</a>.</span>
		{% endif -%}
	</div>
	<div class="dialog__actions">
		<form method="dialog">
			<button {% if showProductGuardianFinal -%} aria-label="{{ translations.AskGuardian }}" {% else -%} aria-label="{{ translations.AskAboutProduct }}" {% endif -%} class="primary-action-button close-js load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".ask-about-product-js" data-url="{{ url }}" {% if showProductGuardianFinal -%} data-include="ask-supervisor" {% else -%} data-include="ask-about-product" {% endif -%}>
				{% if showProductGuardianFinal -%}
					<span>{{ translations.AskGuardian }}</span>
					<svg height="24" width="24">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
					</svg>
				{% else -%}
					<span>{{ translations.AskAboutProduct }}</span>
					<svg height="24" width="24">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
					</svg>
				{% endif -%}
			</button>
		</form>
	</div>
</dialog>
`